import { render, staticRenderFns } from "./UIAlertMessage.vue?vue&type=template&id=2db48d1a&"
import script from "./UIAlertMessage.vue?vue&type=script&lang=ts&"
export * from "./UIAlertMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports